{
  "registerButton": "Registrera dig som användare",
  "registrationSucceeded": "Registreringen lyckades",
  "registrationCancelled": "Registreringen återkallades",
  "registrationFailed": "Ett fel uppstod när användarkontot skulle skapas.",
  "createNewPassword": "Skapa lösenord",
  "createNewPasswordDescription": "I fortsättningen loggar du in på boendesidorna med detta lösenord.",
  "createNewPasswordValidationErrorGeneric": "Lösenordet måste uppfylla alla krav",
  "createNewPasswordValidationErrorMatcingPasswords": "Lösenorden stämmer inte överens",
  "createNewPasswordValidationErrorLength": "Minst 8 tecken",
  "createNewPasswordValidationErrorNumber": "Siffra",
  "createNewPasswordValidationErrorSpecialCharacter": "Specialtecken",
  "createNewPasswordValidationErrorUppercase": "Stor bokstav",
  "createNewPasswordValidationErrorLowercase": "Liten bokstav",
  "createNewPasswordValidationSectionHeader": "Starkt lösenord:",
  "createNewPasswordValidationSectionSubheader": "Tecken med å, ä och ö kan inte användas.",
  "createNewPasswordValidationErrorScandicLetters": "Lösenordet kan inte innehålla tecknen å, ä eller ö",
  "newPasswordLabel": "Lösenord",
  "newPasswordAgainLabel": "Lösenordet på nytt",
  "confirmEmailHeader": "Bekräfta e-postadressen",
  "confirmEmailError": "E-postadressen kunde inte läggas till",
  "confirmEmailLabel": "E-post",
  "confirmEmailSubmit": "Bekräfta e-postadressen",
  "confirmEmailDescription": "E-postadressen utgör användar-ID på boendesidorna.",
  "confirmEmailSubmitError": "E-postadressen kunde inte bekräftas",
  "confirmEmaiCancel": "Avbryt",
  "verificationCodeError": "Koden är felaktig eller föråldrad",
  "verificationCodeSubmit": "Bekräfta",
  "verificationCodeLabel": "Bekräftelsekod",
  "verificationCodeDescription": "Bekräftelsekoden har skickats till adressen",
  "verificationCodeResendDescription": "Om du inte fått koden ska du vänta en stund, kontrollera skräppostmappen eller",
  "verificationCodeResendLink": "skicka koden på nytt",
  "verificationCodeResendStatus": "En ny kod har skickats kl. {{time}}",
  "verificationCodeResendError": "Bekräftelsekoden kunde inte skickas",
  "resendVerificationCode": {
    "linkText": "Skicka bekräftelsekoden på nytt här.",
    "success": "Användarnamnet har bekräftats. Nu kan du logga in med ditt användarnamn och ditt lösenord."
  },
  "ftnCallbackErrorMessage": "Ett fel uppstod när användarkontot skulle skapas.",
  "ftnCallbackErrorDescription": "Vänligen försök registrera dig på nytt. Byt vid behov autentiseringssätt.",
  "ftnCallbackErrorBackButtonText": "Tillbaka till framsidan",
  "continueRegistrationInfo4": "Om du vill byta e-postadress",
  "continueRegistrationInfo3": "Om du inte fick koden (vänta en stund och kontrollera även skräppostmappen) eller om den har hunnit bli ogiltig",
  "continueRegistrationInfo2": "Du har fått en bekräftelsekod till adressen <strong>{{email}}</strong>.",
  "continueRegistrationInfo1": "Din registrering blev tidigare avbruten. Du måste fortfarande bekräfta din e-postadress.",
  "continueRegistrationHeader": "Välkommen tillbaka!",
  "resetRegistrationLinkText": "börja registreringen från början",
  "chooseAuthHeader": "Registrera dig som användare",
  "chooseAuthFtn": "Bankkoder eller mobil-ID",
  "chooseAuthPassport": "Pass eller ID-kort",
  "invitationLoadError": "Det gick inte att läsa in inbjudan.",
  "invitationExpiredTitle": "Inbjudan har gått ut",
  "invitationExpiredDescription": "Den här registreringsinbjudan har gått ut. Be om en ny inbjudan.",
  "invitationAlreadyRegisteredTitle": "Kontot har redan skapats",
  "invitationAlreadyRegisteredDescription": "Ett användarkonto har redan skapats för den här inbjudan. Du kan logga in.",
  "invitationRegisterError": "Registreringen misslyckades.",
  "invitationCreatePasswordHeader": "Skapa lösenord",
  "invitationCreatePasswordDescription": "Du skapar ett användarkonto för e-postadressen {{email}}. Ange ett lösenord för att logga in på boendesidorna i fortsättningen.",
  "registrationWrongDomain": "Påbörja registreringen på: {{url}}."
}
